export default __webpack_public_path__ + "static/media/soundTwo.2604a56c.wav";